var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":"user_info","model":_vm.model,"icon":"mdi-card-account-details-outline"}})
}
var staticRenderFns = []

export { render, staticRenderFns }